import React from 'react'

import PopoverSelectorNew from "../../../../core/gd-components/selector/popover-selector/popover-selector-new"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../core/gd-components/buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../core/gd-components/buttons/control-button/@types"
import Section from "../../../../core/model2/project/section"
import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import sectionPreferences_PopoverMenuOptions from "../../actions/section-preferences-menu-options";

type Props = {
    className?      : string

    section         : Section
    localSettings?  : NavigationMenu_ProjectsLocalSettings

    onChange?       : callback
    onReset?        : callback
}

// const debug = "NavigationMenu_SectionPreferences"
const debug = false

export default function NavigationMenu_SectionPreferences(props: Props) {

    debug && console.log(debug, "section=", props.section)
    debug && console.log(debug, "projectsSorting=", props.section.projectsSorting, "projectsColorize", props.section.projectsColorize)

    return (
        <PopoverSelectorNew
            button      = {
                (isSelected:boolean, onClick:callback)=>{
                    return (
                        <ControlButtonStandard
                            className   = "m-r-3"
                            type        = {ControlButtonType.MORE}
                            size        = {ControlButtonSize.SIZE_24}
                            isSelected  = {isSelected}
                            onClick     = {onClick}
                        />
                    )
                }
            }
            options     = {sectionPreferences_PopoverMenuOptions(props.section, props.localSettings, props.onReset)}
        />
    )
}
